<template>
  <div class="container">
    <form @submit.prevent="onSubmit()">
      <fieldset>
        <label for="login-email">Sähköposti:</label>
        <input v-model="email" type="email" name="email" id="login-email" autocomplete="email">
        <label for="login-password">Salasana:</label>
        <input v-model="password" type="password" name="password" id="login-password" autocomplete="current-password">
        <button type="submit">Kirjaudu sisään</button>
      </fieldset>
      <span v-if="error" class="error">Kirjautuminen epäonnistui, yritä uudelleen.</span>
    </form>
    <router-link :to="{name: 'RegisterView'}">Luo tili</router-link>
    <router-link :to="{name: 'ForgotPasswordView'}">Unohdin salasanani</router-link>
  </div>
</template>

<script>

import { CognitoUserPool, AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js';
import userpoolconfig from './../userpoolconfig'
import types from './../store/types'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'LoginView',
  data () {
    return {
      email: this.$route.query.email || '',
      password: '',
      error: false
    }
  },
  computed: {
    ...mapGetters('Auth', ['loggedIn']),
  },
  methods: {
    onSubmit () {
      console.log('login onSubmit');
      this.error = false;
      const {email, password} = this;
      this.authRequest({email, password}).then(() => {
        const redirect = this.$route.query.redirect || '/';
        this.$router.push(redirect);
      }).catch((err) => {
        this.error = true;
      })
    },
    ...mapActions('Auth', ['authRequest']),
  },
  beforeMount () {
    if (this.loggedIn()) {
      console.log('LoginView beforeMount logged: true');
      const redirect = this.$route.query.redirect || '/';
      this.$router.push(redirect);
    } else {
      console.log('LoginView beforeMount logged: false');
    }
  }
}
</script>

<style lang="scss" scoped>
  @import 'src/color.scss';
  @import 'src/values.scss';

  form {
    text-align: left;
    width: 80%;
    max-width: 400px;
    margin: 1em auto;
  }

  fieldset {
    border: none;
  }

  input, label {
    box-sizing: border-box;
    cursor: pointer;
  }

  input {
    display: block;
    width: 100%;
    margin-bottom: 1em;
    padding: 0.4em 0.3em;
    font-weight: bold;
  }

  label {
    width: 100%;
    display: inline-block;
    margin-bottom: 0.4em;
    font-weight: bold;
  }

  button {
    padding: 10px;
    border: 1px solid $secondary-dark;
    //border-radius: 0.5em;
    //background: linear-gradient($secondary-light, $secondary);
    background: $secondary;
    color: white;
    display: block;
    margin: 0 auto;
    font-size: 110%;
    font-weight: bold;

    transition: $transition-time all;
    &:hover {
      background-color: $secondary-dark;
    }
  }

  button:active,
  button:focus {
    border: 2px solid $secondary-dark;
    padding: 9px;
  }
</style>



// WEBPACK FOOTER //
// src/components/LoginView.vue